export interface NewsArticle {
  id: string
  title: string
  summary: string
  excerpt: string
  icon: string
  iconName: string
  illustrationType: string
  illustrationKey: string
  date: string
  category: string
  categoryId: 'company' | 'product' | 'industry' | 'tech'
  author: string
  position: string
  imageCaption: string
  tags: string[]
  content: string
}

export const buildNewsExcerpt = (content: string, maxLength = 68): string => {
  const plain = content
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()

  if (!plain) return ''
  if (plain.length <= maxLength) return plain
  return `${plain.slice(0, maxLength)}...`
}

export const newsArticles: NewsArticle[] = [
  {
    id: '1',
    title: 'MAGIC发布全新AI驱动DSP平台，引领智能营销新纪元',
    summary: 'MAGIC通过AI驱动DSP将投放从经验决策升级为数据实时决策，核心目标是稳定提升转化效率与ROI。',
    excerpt: '我们很高兴地宣布，MAGIC全新AI驱动的DSP广告平台正式发布。新平台集成了最新的机器学习算法，将革命性地改变数字营销的方式。',
    icon: '🚀',
    iconName: 'rocket',
    illustrationType: 'company',
    illustrationKey: 'company',
    date: '2026-01-20',
    category: '公司动态',
    categoryId: 'company',
    author: '产品团队',
    position: 'MAGIC产品总监',
    imageCaption: 'AI驱动的智能营销平台',
    tags: ['AI营销', 'DSP平台', '机器学习', '智能投放'],
    content: `
      <div class="space-y-6">
        <p><strong>引言</strong></p>
        <p>在数字营销快速发展的今天，传统的人工投放方式已经无法满足企业对精准获客和效果优化的需求。MAGIC经过一年的研发，正式发布了全新AI驱动的DSP广告平台，这将彻底改变数字营销的游戏规则。</p>

        <h3>核心技术突破</h3>
        <p>新平台的核心在于其自主研发的深度学习算法，该算法基于数十亿条用户行为数据训练而成，能够实时分析用户意图，预测转化概率，并自动优化投放策略。</p>

        <h4>1. 智能用户画像</h4>
        <p>平台整合了DMP系统的用户画像数据，能够实时更新用户特征标签，实现真正意义上的精准定向。相比传统的人口统计学定向，我们的AI画像准确率提升了300%以上。</p>

        <h4>2. 实时竞价优化</h4>
        <p>基于强化学习的实时竞价引擎，能够在毫秒级别做出投放决策，确保每一个广告曝光都能获得最大的ROI。测试数据显示，平均CPA降低了45%。</p>

        <h4>3. 创意智能生成</h4>
        <p>平台内置了AI创意生成系统，能够根据产品特性和用户偏好，自动生成个性化的广告创意。A/B测试显示，AI创意的点击率比人工创意高出65%。</p>

        <h3>客户成功案例</h3>
        <p>在beta测试阶段，我们已经服务了50多家企业客户，涵盖了电商、游戏、金融、教育等多个行业。平均来看，客户的转化率提升了180%，ROI提升了320%。</p>

        <h3>未来展望</h3>
        <p>MAGIC将继续投入研发，不断完善AI算法和产品功能。我们的目标是让AI营销真正惠及每一个企业，无论规模大小，都能享受到智能营销带来的红利。</p>

        <h3>落地建议</h3>
        <p>对广告主而言，建议先从单一业务目标切入AI投放，再逐步扩展到跨渠道预算协同，优先建立“数据采集-模型优化-策略回写”的闭环，确保技术升级可被业务持续吸收。</p>

        <p><strong>关于MAGIC</strong></p>
        <p>MAGIC是一家专注于数字营销技术创新的企业，致力于通过AI和大数据技术，为全球企业提供领先的数字营销解决方案。</p>
      </div>
    `
  },
  {
    id: '2',
    title: 'DataGet DMP平台重大更新：新增AI预测功能',
    summary: '本次更新的核心价值在于把用户洞察从“事后分析”前移到“事前预测”，帮助企业提前做增长决策。',
    excerpt: '深入探讨AI技术如何革新数字营销行业，提升广告投放效果，优化用户体验，实现真正的智能营销。',
    icon: '📊',
    iconName: 'data',
    illustrationType: 'product',
    illustrationKey: 'product',
    date: '2025-11-15',
    category: '产品更新',
    categoryId: 'product',
    author: '技术团队',
    position: '首席算法工程师',
    imageCaption: '机器学习驱动营销革命',
    tags: ['机器学习', '算法优化', '数据分析', '营销技术'],
    content: `
      <div class="space-y-6">
        <p><strong>数字营销的智能化时代</strong></p>
        <p>随着人工智能技术的飞速发展，数字营销行业正在经历一场深刻的变革。传统的基于规则和经验的投放方式，正在被基于数据驱动的智能化投放所取代。</p>

        <h3>机器学习在用户定向中的应用</h3>
        <p>用户定向是数字营销的核心环节。机器学习算法能够从海量用户行为数据中学习，识别出高价值用户的特征模式。相比传统的人工定向，机器学习定向的准确率提升了200%以上。</p>

        <h3>出价策略的智能优化</h3>
        <p>实时竞价（RTB）是程序化广告的核心。我们的出价优化算法能够实时分析市场竞争情况、用户转化概率，动态调整出价策略，在保证曝光量的同时最大化ROI。</p>

        <h3>创意效果的预测分析</h3>
        <p>通过深度学习模型，我们能够在创意上线前预测其点击率和转化率。这不仅大大节省了测试成本，还能够快速找到最优的创意方向。</p>

        <h3>技术架构与实现</h3>
        <p>我们的机器学习平台基于TensorFlow构建，采用分布式训练架构，支持在线学习和模型实时更新。整个系统从数据采集到模型部署的全链路延迟控制在100ms以内。</p>

        <h3>未来发展方向</h3>
        <p>未来，我们将继续探索强化学习、图神经网络等前沿技术在营销领域的应用，进一步推动数字营销的智能化进程。</p>

        <h3>应用实践建议</h3>
        <p>企业在部署机器学习营销系统时，应先明确核心业务目标和评估口径，再分阶段接入数据、模型和自动化策略，避免一次性改造带来的组织成本和效果波动。</p>
      </div>
    `
  },
  {
    id: '3',
    title: 'MAGIC全新推荐文章：2025年数字营销行业趋势报告',
    summary: '2025年营销竞争将聚焦在AI能力、私域精细化和合规化增长三条主线上。',
    excerpt: '全面解析2025年数字营销行业发展趋势，把握行业机遇。AI技术、私域流量、跨境电商成为关键词。',
    icon: '📊',
    iconName: 'data',
    illustrationType: 'industry',
    illustrationKey: 'industry',
    date: '2025-08-20',
    category: '行业洞察',
    categoryId: 'industry',
    author: '行业分析师',
    position: '首席战略官',
    imageCaption: '2025数字营销趋势',
    tags: ['数字营销', '行业趋势', 'AI营销', '私域流量'],
    content: `
      <div class="space-y-6">
        <p><strong>2025年数字营销五大趋势</strong></p>
        <p>随着数字技术的快速发展和消费者行为的不断变化，数字营销行业正在经历深刻变革。本报告深入分析2025年数字营销行业的核心趋势，为企业制定营销策略提供参考。</p>

        <h3>趋势一：AI驱动的个性化营销</h3>
        <p>人工智能技术正在重塑数字营销的面貌。从用户画像构建到创意生成，从投放优化到效果预测，AI技术贯穿营销全链路。2025年，AI营销将从概念走向大规模应用，成为企业数字营销的核心竞争力。</p>

        <h4>关键技术突破</h4>
        <p>• 大语言模型驱动的智能内容生成<br>• 计算广告学的实时竞价优化<br>• 多模态AI的创意自动化生产</p>

        <h3>趋势二：私域流量精细化运营</h3>
        <p>随着公域流量成本持续攀升，私域流量运营成为企业必选项。2025年，私域运营将从粗放式转向精细化，通过数据驱动实现用户生命周期价值最大化。</p>

        <h4>运营策略升级</h4>
        <p>• 用户分层运营体系<br>• 自动化营销工具普及<br>• 社群运营深度化</p>

        <h3>趋势三：跨境电商营销爆发</h3>
        <p>中国企业出海热潮推动跨境数字营销需求激增。本地化内容、跨境支付、合规投放成为核心竞争力。预计2025年跨境电商营销市场规模将增长150%。</p>

        <h3>趋势四：视频营销主导地位</h3>
        <p>短视频和直播营销成为主流，视频内容占用户消费时长的70%以上。企业需要构建完整的视频营销体系，从内容策划到投放优化全方位升级。</p>

        <h3>趋势五：隐私计算与数据合规</h3>
        <p>随着数据隐私法规日趋严格，隐私计算技术成为行业热点。联邦学习、安全多方计算等技术将在保证数据安全的前提下实现精准营销。</p>

        <h3>企业应对建议</h3>
        <p>面对这些趋势，企业应该：<br>1. 加大AI技术投入，构建智能化营销体系<br>2. 布局私域流量，降低获客成本<br>3. 关注跨境市场，拓展业务边界<br>4. 强化内容能力，拥抱视频营销<br>5. 重视数据合规，建立可信营销体系</p>

        <h3>执行优先级建议</h3>
        <p>建议企业按“先数据底座、再自动化能力、后规模化投放”的顺序推进，先解决口径一致与指标可解释问题，再扩大投放规模，才能避免增长效率随预算上升而递减。</p>

        <p><strong>关于本报告</strong></p>
        <p>本报告基于MAGIC平台服务的数百家企业数据，结合行业专家访谈，全面呈现2025年数字营销行业的发展趋势。</p>
      </div>
    `
  },
  {
    id: '10',
    title: '私域流量运营的最佳实践分享',
    summary: '私域运营的本质是持续经营用户价值，而不是短期提升触达频次。',
    excerpt: '在流量成本日益增长的今天，私域流量运营已成为企业必备能力。本文分享我们在私域流量运营方面的最佳实践。',
    icon: '💎',
    iconName: 'gem',
    illustrationType: 'industry',
    illustrationKey: 'private-domain',
    date: '2025-06-15',
    category: '行业洞察',
    categoryId: 'industry',
    author: '增长策略团队',
    position: '用户增长负责人',
    imageCaption: '私域运营增长方法论',
    tags: ['私域流量', '用户运营', '复购', 'LTV'],
    content: `
      <div class="space-y-6">
        <p><strong>为什么私域成为企业必选项</strong></p>
        <p>随着公域流量成本持续走高，企业对高质量复购和长期用户价值的需求越来越强。私域运营的本质，不是增加触达频次，而是建立长期、可信、可持续的用户关系。</p>

        <h3>搭建可持续私域体系的三层结构</h3>
        <p>第一层是数据层，统一用户身份和行为口径；第二层是策略层，建立分层运营与自动化流程；第三层是内容层，围绕用户生命周期持续提供价值。</p>

        <h3>高价值用户运营的关键动作</h3>
        <p>通过RFM分层、触点节奏管理和个性化内容分发，企业能够显著提升活跃度和复购率。同时配合优惠策略与服务权益设计，可以有效延长用户生命周期。</p>

        <h3>常见误区与纠偏建议</h3>
        <p>最常见的问题是“只看打开率、不看商业结果”。建议以转化率、复购周期、用户贡献毛利等指标为核心，建立完整的经营看板，避免流于形式。</p>

        <h3>实践总结</h3>
        <p>私域运营并非一次性项目，而是持续迭代的经营系统。先把基础数据打通，再逐步提升自动化程度，最终通过A/B测试形成长期增长飞轮。</p>

        <h3>团队协同建议</h3>
        <p>私域项目要取得稳定结果，必须由市场、运营、产品与客服共建目标体系，统一用户分层与触达规则，确保用户体验、转化效率和服务质量同步提升。</p>
      </div>
    `
  },
  {
    id: '4',
    title: '跨境广告投放的合规要点解析',
    summary: '跨境投放要实现长期增长，必须把合规能力建设为与效果优化同等重要的基础能力。',
    excerpt: '随着企业出海热潮的兴起，跨境广告投放的合规性问题日益重要。本文详细解析跨境广告投放的合规要点。',
    icon: '🌍',
    iconName: 'global',
    illustrationType: 'industry',
    illustrationKey: 'compliance',
    date: '2025-05-10',
    category: '行业洞察',
    categoryId: 'industry',
    author: '合规与法务团队',
    position: '跨境合规顾问',
    imageCaption: '跨境营销合规框架',
    tags: ['跨境营销', '合规', '隐私保护', '国际化'],
    content: `
      <div class="space-y-6">
        <p><strong>出海增长与合规风险并行</strong></p>
        <p>跨境广告为企业带来新增量的同时，也带来了监管政策、平台规则与数据保护方面的复合挑战。投放策略必须从“只追效果”升级为“效果与合规并重”。</p>

        <h3>重点一：素材与落地页信息一致性</h3>
        <p>广告承诺、价格信息、条款说明必须与落地页保持一致，避免误导性描述。金融、医疗、教育等高敏感行业应增加审校流程和法务复核环节。</p>

        <h3>重点二：数据采集与授权链路可追溯</h3>
        <p>用户数据的采集、存储与使用需具备清晰授权记录，尤其在Cookie、设备标识和再营销场景中，要明确告知用途并支持用户撤回授权。</p>

        <h3>重点三：区域政策差异化治理</h3>
        <p>不同地区对隐私、内容和广告标注要求差异显著。建议建立“区域清单 + 审核模板 + 应急预案”机制，减少投放中断和账户风险。</p>

        <h3>执行建议</h3>
        <p>在组织层面设立跨部门合规小组，形成“策略评估-上线前审校-上线后巡检”的闭环。这样既能保障增长效率，也能降低长期运营风险。</p>

        <h3>风险应急机制</h3>
        <p>建议建立账户异常、素材下架、政策更新三类预警流程，并准备替代素材和应急投放计划，确保在监管或平台规则变化时业务不发生大幅中断。</p>
      </div>
    `
  },
  {
    id: '5',
    title: '媒体方如何最大化广告收益？',
    summary: '媒体收益增长的关键是“收益与体验双优”，而非单纯增加广告曝光。',
    excerpt: '作为媒体方，如何在保证用户体验的前提下最大化广告收益？本文分享媒体变现的策略和技巧。',
    icon: '📺',
    iconName: 'ssp',
    illustrationType: 'tech',
    illustrationKey: 'tech',
    date: '2025-01-25',
    category: '技术分享',
    categoryId: 'tech',
    author: '商业化团队',
    position: 'SSP解决方案专家',
    imageCaption: '媒体变现优化策略',
    tags: ['SSP', '媒体变现', '填充率', 'eCPM'],
    content: `
      <div class="space-y-6">
        <p><strong>收益最大化不是“堆广告位”</strong></p>
        <p>媒体变现的核心目标是在不伤害用户体验的前提下，持续提升单位流量价值。短期激进策略可能带来收益波动，但往往会牺牲留存和长期价值。</p>

        <h3>从流量结构入手做精细化运营</h3>
        <p>建议按频道、场景和用户分层拆分流量结构，针对高价值流量配置更优竞价策略，针对低价值流量做填充优化，提升整体收益效率。</p>

        <h3>价格策略与竞价机制协同优化</h3>
        <p>通过Floor Price分层设置、竞价路径优化和需求方质量管理，可以在保障填充率的同时稳步抬升eCPM，避免“高价低填充”或“高填充低单价”的极端情况。</p>

        <h3>体验指标纳入变现决策</h3>
        <p>应将页面停留时长、跳出率、次日留存等体验指标同步纳入收益评估。只有在“收益+体验”双指标改善时，策略调整才算有效。</p>

        <h3>长期策略</h3>
        <p>搭建可视化收益看板，持续进行实验迭代。通过小步快跑的方式验证广告位策略和需求方组合，逐步形成适合自身业务的最优变现模型。</p>

        <h3>组织保障建议</h3>
        <p>建议媒体侧建立专门的商业化增长小组，按周复盘收益与体验双指标，并与产品和技术团队协同优化页面策略，形成稳定可复制的收益提升机制。</p>
      </div>
    `
  },
  {
    id: '6',
    title: 'MAGIC与某知名游戏公司达成战略合作',
    summary: '此次合作的主旨是以数据驱动的全链路方法论，系统提升游戏业务的获客与留存效率。',
    excerpt: '我们很高兴地宣布，MAGIC与某知名游戏公司达成战略合作，为其提供全方位的数字营销解决方案。',
    icon: '🤝',
    iconName: 'handshake',
    illustrationType: 'company',
    illustrationKey: 'partnership',
    date: '2024-09-15',
    category: '公司动态',
    categoryId: 'company',
    author: '市场与合作团队',
    position: '商务总监',
    imageCaption: '战略合作项目启动',
    tags: ['战略合作', '游戏行业', '增长', '品牌'],
    content: `
      <div class="space-y-6">
        <p><strong>合作背景</strong></p>
        <p>在游戏行业竞争加剧、买量成本攀升的背景下，双方决定围绕获客效率、用户留存与商业化能力展开深度合作，探索可复制的增长方案。</p>

        <h3>合作范围</h3>
        <p>本次合作覆盖策略咨询、投放执行、数据中台对接、创意测试与复盘优化，形成从投放前到投放后的完整闭环。</p>

        <h3>阶段成果</h3>
        <p>项目试运行期间，关键渠道的转化成本显著下降，核心人群留存稳定提升，同时广告素材迭代效率和投放响应速度均有提升。</p>

        <h3>方法论沉淀</h3>
        <p>双方共同建立了“目标拆解-人群策略-创意实验-预算协同-复盘迭代”的作战框架，后续将用于更多产品线和海外市场拓展。</p>

        <h3>未来规划</h3>
        <p>下一阶段将重点推进跨区投放与本地化运营，提升全球用户增长效率，并持续强化品牌与效果协同。</p>

        <h3>联合创新方向</h3>
        <p>双方还将围绕创意自动化、分渠道预算调度和人群深度运营开展联合实验，把项目经验沉淀为平台能力，进一步提升跨项目复用效率。</p>
      </div>
    `
  },
  {
    id: '7',
    title: 'Adget DSP平台全新优化算法上线',
    summary: '新算法通过分层出价与预算节奏控制，实现投放稳定性与转化效率同步提升。',
    excerpt: 'Adget DSP平台全新优化算法正式上线，基于深度学习的智能投放算法，将显著提升广告投放效果。',
    icon: '🎯',
    iconName: 'targeting',
    illustrationType: 'product',
    illustrationKey: 'optimization',
    date: '2024-05-20',
    category: '产品更新',
    categoryId: 'product',
    author: '算法工程团队',
    position: '投放算法负责人',
    imageCaption: 'Adget DSP算法升级',
    tags: ['DSP', '算法优化', '自动出价', '转化提升'],
    content: `
      <div class="space-y-6">
        <p><strong>版本升级目标</strong></p>
        <p>本次算法升级聚焦三个核心问题：冷启动阶段学习慢、预算分配不稳定、转化波动大。通过模型结构与策略引擎联动，显著改善投放稳定性。</p>

        <h3>关键优化一：分层出价模型</h3>
        <p>新版本将流量按价值分层，分别应用差异化出价策略，提升高质量流量竞争力，同时控制低质量流量成本浪费。</p>

        <h3>关键优化二：预算节奏自适应</h3>
        <p>系统会根据时段表现与转化反馈自动调整预算释放速度，避免“前期花太快、后期跑不动”的常见问题。</p>

        <h3>关键优化三：创意反馈闭环</h3>
        <p>将创意点击、互动、转化信号纳入模型训练，形成“投放-反馈-再训练”的快速迭代机制，提高素材生命周期管理效率。</p>

        <h3>上线建议</h3>
        <p>推荐采用灰度切换与AB并行验证方式，逐步扩大新算法覆盖范围，确保业务平滑过渡并获得可量化提升。</p>

        <h3>持续优化机制</h3>
        <p>算法上线只是起点，建议持续维护“数据质量监控-模型效果评估-策略回收再训练”流程，以月度节奏进行模型迭代，保持长期竞争力。</p>
      </div>
    `
  },
  {
    id: '8',
    title: '大数据技术在用户画像中的应用',
    summary: '用户画像的真正价值在于把数据能力转化为可执行的业务策略与持续优化机制。',
    excerpt: '用户画像是精准营销的基础，本文深入探讨大数据技术在用户画像构建中的应用实践。',
    icon: '🔍',
    iconName: 'search',
    illustrationType: 'tech',
    illustrationKey: 'profile',
    date: '2024-02-10',
    category: '技术分享',
    categoryId: 'tech',
    author: '数据科学团队',
    position: '资深数据工程师',
    imageCaption: '用户画像构建流程',
    tags: ['用户画像', '大数据', '标签体系', '数据治理'],
    content: `
      <div class="space-y-6">
        <p><strong>用户画像为何重要</strong></p>
        <p>精准营销的前提是“理解用户”。用户画像不仅用于投放定向，更是产品运营、内容推荐和客户服务策略的重要基础设施。</p>

        <h3>画像建设的基础：数据治理</h3>
        <p>在画像体系建设初期，最关键的是统一主键、口径和采集标准。没有稳定的数据治理，后续标签和模型都会受到污染。</p>

        <h3>标签体系设计方法</h3>
        <p>建议采用“基础属性 + 行为偏好 + 价值分层 + 风险特征”的四层标签体系，兼顾业务可解释性与策略可执行性。</p>

        <h3>模型与业务联动机制</h3>
        <p>画像并非静态资产。应建立标签更新频率与业务策略触发机制，例如在高意向标签变化时自动调整触达策略。</p>

        <h3>实践建议</h3>
        <p>把“可用”放在“完美”之前，先在关键场景跑通闭环，再逐步扩大数据覆盖和模型复杂度，持续提升画像质量与业务价值。</p>

        <h3>治理与迭代建议</h3>
        <p>建议为核心标签设置生命周期和质量评分，定期淘汰失效标签并补充新特征，确保画像系统与真实业务场景同步演进。</p>
      </div>
    `
  },
  {
    id: '9',
    title: '2024年移动广告市场展望',
    summary: '移动广告已进入精细化竞争阶段，核心胜负手是归因能力与创意迭代效率。',
    excerpt: '随着移动设备的普及和5G网络的发展，移动广告市场迎来了新的机遇。本文展望2024年移动广告市场的发展趋势。',
    icon: '📱',
    iconName: 'mobile',
    illustrationType: 'industry',
    illustrationKey: 'mobile',
    date: '2023-11-05',
    category: '行业洞察',
    categoryId: 'industry',
    author: '行业洞察团队',
    position: '移动营销分析师',
    imageCaption: '移动广告市场趋势',
    tags: ['移动广告', '5G', '效果营销', '市场趋势'],
    content: `
      <div class="space-y-6">
        <p><strong>市场背景</strong></p>
        <p>移动端已成为用户触达和商业转化的核心战场。随着5G普及和内容消费习惯变化，移动广告市场正进入“高质量增长”阶段。</p>

        <h3>趋势一：短视频与应用内广告并行增长</h3>
        <p>短视频场景保持高活跃，应用内原生广告在电商、工具和内容平台中持续增长。品牌与效果预算进一步融合，投放策略更强调场景协同。</p>

        <h3>趋势二：归因能力成为竞争门槛</h3>
        <p>多端触点和隐私政策变化使归因更复杂。企业需要构建可解释、可验证的归因模型，以保障预算分配和投放评估的可靠性。</p>

        <h3>趋势三：创意生产效率决定投放效率</h3>
        <p>移动场景下素材衰减更快，创意测试和快速迭代能力成为决定ROI的重要因素。数据反馈与素材生产流程必须深度联动。</p>

        <h3>企业策略建议</h3>
        <p>建议企业围绕“数据底座、归因体系、创意工厂、自动化投放”四个维度建设能力，形成可持续优化的移动广告增长系统。</p>

        <h3>中长期布局</h3>
        <p>未来移动广告竞争会进一步向“内容质量 + 技术效率 + 合规能力”三位一体演进，企业需要同步建设创意能力、投放引擎和数据治理体系，才能保持稳定增长。</p>
      </div>
    `
  }
]

export const newsById: Record<string, NewsArticle> = Object.fromEntries(
  newsArticles.map((article) => [article.id, article])
)
